import React, { useState, useEffect } from 'react';

const STORAGE_KEY = 'theme'; // 'dark' | 'light'

const ThemeToggle = () => {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      const useDark = saved ? saved === 'dark' : prefersDark;

      setIsDark(useDark);
      document.body.classList.toggle('dark-theme', useDark);
      document.body.classList.toggle('light-theme', !useDark);
    } catch (e) {
      // Fallback if localStorage is unavailable
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      setIsDark(prefersDark);
      document.body.classList.toggle('dark-theme', prefersDark);
      document.body.classList.toggle('light-theme', !prefersDark);
    }
  }, []);

  const toggleTheme = () => {
    const newIsDark = !isDark;
    setIsDark(newIsDark);

    document.body.classList.toggle('dark-theme', newIsDark);
    document.body.classList.toggle('light-theme', !newIsDark);

    try {
      localStorage.setItem(STORAGE_KEY, newIsDark ? 'dark' : 'light');
    } catch (e) {
      // ignore write errors
    }
  };

  return (
    <button className="theme-toggle" onClick={toggleTheme}>
      <i className={isDark ? 'fas fa-sun' : 'fas fa-moon'}></i>
    </button>
  );
};

export default ThemeToggle;
